module.exports = __webpack_public_path__ + "tablet.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/tablet.svg
// module id = 1152
// module chunks = 10